import React from 'react';
import {
    BlockGuestAccessTooltip,
    DirectURLTooltip,
    FamilyCategoryTooltip,
    NavigationAssignmentToolTip
} from "components/break/tooltips/breaks-nav-site-filter-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {isBreakInHub, isNoU} from "../../../../utils/DBUtils";


export default {
    key: "breaksNavAndFilters",
    showSection: (formProxy) => !isBreakInHub(formProxy.currentBaseResource),
    props: {
        headerKey: 'editbreak.section.navandfilters.heading'
    },

    fields: [
        // {
        //     name: 'categories',
        //     type: 'breakCategoryEditor',
        //     props: {
        //     }
        // },
        // {
        //     type: "breakTagEditor",
        //     name: "breakTagLabels",
        //     props: {
        //         labelKey: 'editbreak.general.breakTags'
        //     }
        // },

        {
            name: "hideOnHomepage",
            type: "yesnoradio",

            props: {
                labelKey: "editbreak.breaksNavFilters.hideOnHomepage",
                helpContent: <DirectURLTooltip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksNavFilters.hideOnHomepage'}/></IntlProvider>
            }
        },
        {
            name: "requiresCategoryFilter",
            type: "yesnoradio",
            props: {
                labelKey: "Only Show on Category & Tag Pages (Not on Homepage)",
                helpContent: <FamilyCategoryTooltip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksNavFilters.requiresCategoryFilter'}/></IntlProvider>
            }
        },
        {
            type: 'hardcodedText',
            showField: (proxy) => {
                console.log(`here`, proxy.currentBaseResource)
                return ((proxy.currentBaseResource.hideOnHomepage == true) && (proxy.currentBaseResource.requiresCategoryFilter == true))
            },
            props: {
            text: "⚠️ Only Show on Category & Tag Pages setting has no effect because View Only as Direct URL set to Yes"
            }
        },
        // {
        //     name: "blockGuestAccess",
        //     type: "yesnoradio",

        //     props: {
        //         labelKey: "editbreak.breaksNavFilters.blockGuestAccess",
        //         helpContent: <BlockGuestAccessTooltip/>,
        //         helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.breaksNavFilters.blockGuestAccess'}/></IntlProvider>
        //     }
        // }
    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksNavAndFilters.js